import { root, id } from './feeds';

export const feeds = {
  ...root,
  id: {
    ...id,
  },
};
